import React from 'react';
import { Dropdown } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import FullscreenToggle from '../../components/FullscreenToggle';
import LogoutLink from './Logout';

// Simple initials avatar — avoids the clinical app's photo-fetch dependency.
function Initials({ name }) {
  const initials = (name || 'U')
    .split(' ').filter(Boolean).slice(0, 2).map(w => w[0].toUpperCase()).join('');
  return (
    <span className="header-profile-avatar d-inline-flex align-items-center justify-content-center"
      style={{ width: 24, height: 24, borderRadius: '50%', background: 'var(--primary)', color: '#fff', fontWeight: 600, fontSize: 11 }}>
      {initials}
    </span>
  );
}

const Header = () => {
  const { username, full_name } = useSelector(state => state.auth.auth);
  const display = full_name || username || 'User';

  return (
    <div className="header">
      <div className="header-content">
        <nav className="navbar navbar-expand">
          <div className="collapse navbar-collapse justify-content-between">
            <div className="header-left">
              <div className="dashboard_bar">
                <Link to="/" style={{ fontSize: 15, fontWeight: 700, textDecoration: 'none', color: 'inherit' }}>
                  PAUL
                </Link>
              </div>
            </div>
            <ul className="navbar-nav header-right">
              <Dropdown as="li" className="nav-item header-profile">
                <Dropdown.Toggle className="nav-link i-false" as="a" style={{ cursor: 'pointer' }}>
                  <Initials name={display} />
                  <div className="header-info">
                    <span>Hello,<strong> {display}</strong></span>
                  </div>
                </Dropdown.Toggle>
                <Dropdown.Menu align="end" className="dropdown-menu-right">
                  <div className="dropdown-item-text small text-muted">Signed in as {display}</div>
                  <LogoutLink />
                </Dropdown.Menu>
              </Dropdown>
              <li className="nav-item">
                <FullscreenToggle />
              </li>
            </ul>
          </div>
        </nav>
      </div>
    </div>
  );
};

export default Header;
